/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetScheduleEnabledRequestBody,
  SetScheduleEnabledRequestBody$Outbound,
  SetScheduleEnabledRequestBody$outboundSchema,
} from "../components/setscheduleenabledrequestbody.js";

export type SetDeviceIntegrationScheduleEnabledSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SetDeviceIntegrationScheduleEnabledRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setScheduleEnabledRequestBody: SetScheduleEnabledRequestBody;
};

/** @internal */
export type SetDeviceIntegrationScheduleEnabledSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetDeviceIntegrationScheduleEnabledSecurity$outboundSchema:
  z.ZodMiniType<
    SetDeviceIntegrationScheduleEnabledSecurity$Outbound,
    SetDeviceIntegrationScheduleEnabledSecurity
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setDeviceIntegrationScheduleEnabledSecurityToJSON(
  setDeviceIntegrationScheduleEnabledSecurity:
    SetDeviceIntegrationScheduleEnabledSecurity,
): string {
  return JSON.stringify(
    SetDeviceIntegrationScheduleEnabledSecurity$outboundSchema.parse(
      setDeviceIntegrationScheduleEnabledSecurity,
    ),
  );
}

/** @internal */
export type SetDeviceIntegrationScheduleEnabledRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  SetScheduleEnabledRequestBody: SetScheduleEnabledRequestBody$Outbound;
};

/** @internal */
export const SetDeviceIntegrationScheduleEnabledRequest$outboundSchema:
  z.ZodMiniType<
    SetDeviceIntegrationScheduleEnabledRequest$Outbound,
    SetDeviceIntegrationScheduleEnabledRequest
  > = z.pipe(
    z.object({
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      setScheduleEnabledRequestBody:
        SetScheduleEnabledRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
        setScheduleEnabledRequestBody: "SetScheduleEnabledRequestBody",
      });
    }),
  );

export function setDeviceIntegrationScheduleEnabledRequestToJSON(
  setDeviceIntegrationScheduleEnabledRequest:
    SetDeviceIntegrationScheduleEnabledRequest,
): string {
  return JSON.stringify(
    SetDeviceIntegrationScheduleEnabledRequest$outboundSchema.parse(
      setDeviceIntegrationScheduleEnabledRequest,
    ),
  );
}
